import { BatchEditCampaignPage } from 'components/BatchEditCampaign/BatchEditCampaignPage';
import { BatchEditCampaignSection } from 'components/BatchEditCampaign/BatchEditCampaignSection';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { InfoDisplaySectionTitle } from 'components/InfoDisplaySection/InfoDisplaySection';
import i18n from 'i18n';
import { LimitationSummaryStateContentModel } from './LimitationSummaryStateContentModel';
import { SummaryDetails } from 'components/FlowSummarySection/FlowSummarySection';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import styles from './limitationSummaryStateContent.module.scss';

export const LimitationSummaryStateContent: React.FC<{
  model: () => LimitationSummaryStateContentModel;
}> = ({ model: useModel }) => {
  const {
    title,
    ignoreCampaignHint,
    limitationSummaryTitle,
    limitationSummaryData,
    ignoreCampaignSummaryTableData
  } = useModel();

  if (!limitationSummaryData) {
    return <LoadingIndicator />;
  }

  return (
    <BatchEditCampaignPage title={title}>
      <BatchEditCampaignSection
        title={i18n.t('batchEditCampaignSummary.labels.checkYourSettings')}
      >
        <div style={{ padding: '30px' }}>
          <InfoDisplaySectionTitle
            className={styles.limitationSummaryTitle}
            title={limitationSummaryTitle}
          />
          <SummaryDetails summaryData={limitationSummaryData} />
        </div>
        {ignoreCampaignSummaryTableData &&
          ignoreCampaignSummaryTableData.data.length > 0 && (
            <>
              <InfoDisplaySectionTitle
                title={i18n.t('modifyLimitationState.titles.ignoreCampaigns')}
                hint={ignoreCampaignHint}
                className={styles.ignoreCampaignSummaryTitle}
              />
              <div className={styles.ignoreCampaignSummaryContent}>
                <StickableTanstackTable
                  keyField='id'
                  data={ignoreCampaignSummaryTableData.data}
                  columns={ignoreCampaignSummaryTableData.columns}
                  hidePagination={true}
                  className={styles.ignoreCampaignSummaryTable}
                />
              </div>
            </>
          )}
      </BatchEditCampaignSection>
    </BatchEditCampaignPage>
  );
};
